import React, { Component } from "react"
import { connect } from "react-redux"
import marked from "marked"
import PropTypes from "prop-types"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import faKey from "@fortawesome/fontawesome-free-solid/faKey"
import faCheck from "@fortawesome/fontawesome-free-solid/faCheck"
import faExclamationTriangle from "@fortawesome/fontawesome-free-solid/faExclamationTriangle"
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes"
// import { apiUrl } from '../config/config';
import { toggleModal } from "../lib/util"

class RegisterSerial extends Component {
  state = {
    modalActive: false,
  }

  toggleModal = () => {
    this.setState(
      {
        modalActive: !this.state.modalActive,
      },
      () => {
        toggleModal(this.state.modalActive)
      }
    )
  }

  render() {
    const { pages, serial, valid } = this.props
    const serialHint = pages.find((page) => page.name === "serial_hint")
    const helpText =
      serial.length > 0
        ? valid
          ? "必填"
          : "產品序號共 9 碼數字"
        : "必填"

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">產品序號</label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control is-expanded has-icons-left has-icons-right">
              <input
                className={valid ? "input is-success" : "input"}
                type="text"
                id="register-serial-input"
                value={serial}
                placeholder="產品序號共 9 碼數字"
                required
                onChange={(e) => {
                  let value = e.target.value
                  if (value.length > 9) {
                    value = value.substr(0, 9)
                  }
                  this.props.handleChange(value, "serial")
                }}
              />
              <span className="icon is-small is-left">
                <FontAwesomeIcon className="icon" icon={faKey} />
              </span>
              <span className="icon is-small is-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={valid ? faCheck : faExclamationTriangle}
                />
              </span>
            </p>
            <div className="help-wrapper">
              <p className="help is-danger">{helpText}</p>
              {serialHint && (
                <p className="help is-serial-hint" onClick={this.toggleModal}>
                  找不到序號?
                </p>
              )}
            </div>
          </div>
        </div>

        {serialHint && (
          <div
            className={
              this.state.modalActive
                ? "modal modal-serial-hint is-active"
                : "modal modal-serial-hint"
            }
          >
            <div
              className="modal-background"
              role="button"
              tabIndex={0}
              onClick={this.toggleModal}
              onKeyUp={this.toggleModal}
            />
            <div
              className="modal-content"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation()
              }}
              onKeyUp={(e) => {
                e.stopPropagation()
              }}
            >
              <div className="card">
                <button
                  className="card-close"
                  aria-label="close"
                  onClick={this.toggleModal}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
                {/*
                  <div className="card-content">
                      <div className="card-content-header">
                          <h1>如何找到產品序號</h1>
                      </div>
                      <div className="card-content-body">
                          <p>如下圖範例，序號所在位置通常位於機器外箱側邊的白色貼紙上或是在機器本體會有一張白色小貼紙上面會有序號，正確的序號為九個數字。</p>
                      </div>
                      <div className="card-content-footer">
                          <img src={`${apiUrl}/uploads/ddb6be1c6d6d4b4989849c8a9bde018f.png`} alt="Serial No Hint"></img>
                      </div>
                  </div>
                  */}

                <div
                  className="card-content"
                  dangerouslySetInnerHTML={{
                    __html: marked(serialHint.content),
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

RegisterSerial.propTypes = {
  handleChange: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  pages: state.pages,
})

export default connect(mapStateToProps)(RegisterSerial)



// WEBPACK FOOTER //
// ./src/components/RegisterSerial.js